import { useEffect, useState } from "react";
import {getFileType} from "../util/helpers"

const FileViewer = ({url, mimeType})=>{
  const [fileType, setFileType] = useState('');
  

  useEffect(()=>{
    if(url){
      let type = getFileType(url);
      if (type === 'unknown' && mimeType) {
        if (mimeType.startsWith('image/')) type = 'image';
        else if (mimeType.startsWith('video/')) type = 'video';
        else if (mimeType.startsWith('application/') || mimeType.startsWith('text/')) type = 'document';
      }
      setFileType(type);
    }
    
  },[url, mimeType]);

  const handleFileClick = () => {
    window.open(url, '_blank');
  }
    return <div className="file-container">
        {fileType === "image" && <ImageViewer url={url} onClick={handleFileClick}/>}
        {fileType === "document" && <DocumentViewer url={url} onClick={handleFileClick}/>}
        {fileType === "video" && <VideoPlayer url={url} onOpenExternal={handleFileClick}/>}
        {fileType === "unknown" && null}
  </div>
  
}

const DocumentViewer = ({ url, onClick }) => {
  return <div style={{ position: 'relative', width: '100%', height: '100%' }}>
    <iframe
      src={url}
    ></iframe>
    <div
      onClick={() => onClick()}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        cursor: 'pointer',
        zIndex: 1,
        backgroundColor: 'transparent',
      }}
    ></div>
  </div>

}

const ImageViewer = ({url,onClick}) => {
  return <img src={url} alt="Deliverables Image file" height="100%" width="100%" onClick={()=>onClick()}/>
}

const VideoPlayer = ({url, onOpenExternal})=>{
  // Detect video type from URL
  const getVideoType = (videoUrl) => {
    if (!videoUrl) return 'video/mp4';
    const lowerUrl = videoUrl.toLowerCase();
    if (lowerUrl.includes('.webm')) return 'video/webm';
    if (lowerUrl.includes('.mov')) return 'video/quicktime';
    if (lowerUrl.includes('.avi')) return 'video/x-msvideo';
    if (lowerUrl.includes('.ogv') || lowerUrl.includes('.ogg')) return 'video/ogg';
    return 'video/mp4'; // default
  };

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <video
        controls
        style={{ 
          width: '100%', 
          height: '100%', 
          objectFit: 'contain',
          backgroundColor: '#000'
        }}
        preload="metadata"
      >
        <source
          src={url}
          type={getVideoType(url)}
        />
        Your browser does not support the video tag.
      </video>
      {onOpenExternal && (
        <button 
          onClick={onOpenExternal}
          style={{
            position: 'absolute',
            top: '8px',
            right: '8px',
            padding: '4px 8px',
            fontSize: '11px',
            backgroundColor: 'rgba(0,0,0,0.7)',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            zIndex: 10
          }}
        >
          Open ↗
        </button>
      )}
    </div>
  );
}

export default FileViewer;